import React, { Component } from 'react';

import './Card.css';
import HTMLLogo from '../images/html.png';
import CSSLogo from '../images/css.png';
import JavaScriptLogo from '../images/javascript.png';
import ReactLogo from '../images/react.png';
import netlifyLogo from '../images/netlify.png';
import jestLogo from '../images/jest.png';
import PythonLogo from '../images/python.png';
import herokuLogo from '../images/heroku.jpg';

class CardC extends Component {
    render() {
        return (
            <div className="Card"> {/* 3rd card start */}
                <h2>IdealMe</h2>
                <h4>HTML, CSS, JavaScript, TDD: Jest/Enzyme, React, Python, SQLite, Netlify, Heroku</h4>
                <p>A calorie tracking app to allow users to be the person they want to see in the mirror</p>
                <div className="card-lang">
                <img src={HTMLLogo} alt="HTM5" /> &nbsp; 
                <img src={CSSLogo} alt="CSS3" /> &nbsp; 
                <img src={JavaScriptLogo} alt="JavaScript" /> &nbsp; 
                <img src={ReactLogo} alt="React" /> &nbsp; 
                <img src={netlifyLogo} alt="Netlify" /> 
                <img src={jestLogo} alt="Jest" /> &nbsp;
                <img src={PythonLogo} alt="Python" />
                <img src={herokuLogo} alt="heroku" /> &nbsp;

                </div><br />
                <div className="card-nav">
                    <div className="card-nav-left">
                        <a href="https://github.com/FopeA6/IdealMe" target="_blank" rel="noopener noreferrer">View Source Code 
                        + Check out the test coverage!</a>
                    </div>
                    <div className="card-nav-right">
                        <a href="https://idealme.netlify.app/" target="_blank" rel="noopener noreferrer">View Project</a>
                    </div>
                </div>
            </div>
        );
    }
}

export default CardC
